import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import AddStaffButton from "./AddStaffButton";
import StaffListingActions from "./StaffListingActions";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import QuestionIcon from "assets/images/question_mark.svg";
import styles from "../staff.module.scss"
import StaffHelpGuide from "./modals/StaffHelpGuide";

const PageHeader = ({
  officeDetail,
  staffMembers,
  officeActive,
  officeId,
  location,
  t,
  downloadAllExportFile,
  globalStaffPage,
  allSelectedData,
  selectedId,
  resetApi
}) => {
  const {
    commonOwnerData: selectedOwner,
    isStaff,
    isOwner,
    dataAccessValues,
  } = useAccountOwnerCommon();

  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const globalStaffAccess =
    globalStaffPage && (isOwner || (isStaff && dataAccessValues.isAdmin));

  return (
    <div className="row no-gutters align-items-center">
      <div className="col-md-7">
        <h2 className="page-title page_title_margin_bottom page_title_margin_top">
          {t("staffMembers")}
        </h2>
        {!globalStaffPage && (
          <p className="sub-title mb-0">{officeDetail?.name || null}</p>
        )}
      </div>
      <div className={`col-md-5 align-items-center d-flex   justify-content-end ${styles["staff-help-box-wrapper"]}`}>
        <button
          type="button"
          className={styles.question_btn}
          onClick={() => setIsInfoModalOpen(true)}
        >
          <img src={QuestionIcon} alt="QuestimIcon" />
          <p className="m-0">{t("navbar.help")}</p>
        </button>
        <div className={`${styles["sperator"]}`}></div> 

        {(globalStaffAccess || !globalStaffPage) && (
          <StaffListingActions
            downloadAllExportFile={downloadAllExportFile}
            allSelectedData={allSelectedData}
            globalStaffPage={globalStaffPage}
            selectedId={selectedId}
            officeId={officeId}
            resetApi={resetApi}
          />
        )}
        {staffMembers &&
          staffMembers?.length > 0 &&
          (globalStaffAccess || officeActive) && (
            <AddStaffButton
              officeId={officeId}
              location={location}
              variant="link"
              globalStaffPage={globalStaffPage}
            />
          )}
      </div>
      {isStaff && globalStaffPage&&selectedOwner?.id && (
        <div className="show-owner-name-text mt-3">
              {t("accountPreferences.showingTemplates")}{" "}
              <span>
                '{selectedOwner.firstName} {selectedOwner.lastName}'
              </span>
              {t("dashBoard.office")}        
        </div>
      )}
      {isInfoModalOpen && (
        <StaffHelpGuide
          isOpen={isInfoModalOpen}
          onClose={setIsInfoModalOpen}
          globalStaffPage={globalStaffPage}
        />
      )}
    </div>
  );
};

export default withTranslation()(PageHeader);
